<template>
  <div>
    <slot
      :saveExercise="saveExercise"
      :refItems="refItems"
      :exercise="exercise"
    ></slot>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
// import lodash from "lodash";

export default {
  name: "ExerciseLogic",
  data() {
    return {
      componentReady: false,
      intervalId: null,
      exercise: null,
      refItems: null,
      dialog: false,
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.init();
    next();
  },
  mounted() {
    this.init();
  },
  props: {
    exCollection: String,
    refCollection: String,
    doc: Object,
    shared: {
      type: Boolean,
      default: false,
    },
    refShared: {
      type: Boolean,
      default: false,
    },
    saveState: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    saveState(val) {
      if (val) {
        this.saveExercise(false);
      }
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    init() {
      let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function() {
        vm.checkStatus();
      }, 300);
    },
    checkStatus() {
      if (
        this.currentProjectModel &&
        this.currentProjectModel.id &&
        this.currentUser
      ) {
        this.componentReady = true;
        this.$emit("ready");
        clearInterval(this.intervalId);
        if (this.refCollection) {
          this.prePopulate();
          this.getExercise();
        } else {
          this.getExercise();
        }
      }
    },
    prePopulate() {
      console.log("get reference");
      let ref = fb[this.refCollection].where(
        "pid",
        "==",
        this.currentProjectModel.id
      );
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        if (items.length) {
          this.refItems = items;
          this.$emit("loadedRefs", this.refItems);
        }
      });
    },
    getExercise() {
      console.log("get exercise", this.shared);
      let uid = this.shared ? "shared" : this.currentUser.uid;
      let ref = fb[this.exCollection]
        .where("uid", "==", uid)
        .where("pid", "==", this.currentProjectModel.id);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        if (items.length) {
          this.exercise = items[0];
          this.$emit("loadedEx", this.exercise);
        }
      });
    },
    saveExercise(notify) {
      // check if exercise exists
      console.log("saving exercise");
      let ref;
      let uid = this.shared ? "shared" : this.currentUser.uid;

      // let vm = this;
      if (this.exercise == null) {
        console.log("no exercise");
        ref = fb[this.exCollection].doc();
      } else {
        console.log("has exercise", this.exercise.id);
        ref = fb[this.exCollection].doc(this.exercise.id);
      }

      console.log("id", ref.id);
      console.log("uid", uid);
      console.log("pid", this.currentProjectModel.id);
      console.log("doc", this.doc);

      ref
        .set({
          updatedOn: new Date(),
          id: ref.id,
          uid: uid,
          pid: this.currentProjectModel.id,
          doc: this.doc,
        })
        .then(() => {
          this.exercise = ref;
          if (notify) {
            this.$emit("saved");
          } else {
            this.$emit("savedNext");
          }
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    testFunction() {
      console.log("test Function");
    },
  },
};
</script>
